import {parse} from 'csv-parse/browser/esm/sync';
import {z} from 'zod';

export default async function parseFileAsCsv<T extends z.ZodSchema>(file: File, zodSchema: T): Promise<z.infer<T>[]> {
  const text = await file.text();
  const csv = parse(text, {
    columns: true,
  });
  return csv.map((row: any) => zodSchema.parse(row));
}
